var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.canBeViewed)?_c('am2-navbar',{directives:[{name:"ar-sticky-top",rawName:"v-ar-sticky-top",value:({
    priority: 1,
  }),expression:"{\n    priority: 1,\n  }"}],attrs:{"menu":_vm.menu}}):_vm._e(),_vm._v(" "),(_vm.canBeViewed)?_c('nuxt-child',{staticClass:"admin-content"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }